<template>
  <el-card>
    <el-row class="game-bd__title">游戏BD</el-row>
    <!-- 搜索 -->
    <el-row class="game-bd__search">
      <span>rid：</span>
      <el-input
        style="width: 200px"
        v-model="search.rid"
        placeholder="请输入rid"
      ></el-input>
      <el-button style="margin-left: 10px" type="primary" @click="getList(1)"
        >search</el-button
      >
      <el-button style="margin-left: 10px" type="success" @click="show(0)"
        >注册</el-button
      >
      <el-button style="margin-left: 10px" type="warning" @click="show(1)"
        >升级BD</el-button
      >
    </el-row>
    <!-- 表格 -->
    <el-row>
      <el-table border :data="tableList">
        <el-table-column prop="rid" label="rid" align="center">
        </el-table-column>
        <!-- <el-table-column prop="bdId" label="BDId" align="center">
        </el-table-column> -->
        <el-table-column prop="name" label="昵称" align="center">
        </el-table-column>
        <el-table-column prop="gender" label="身份" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.gender == 1" type="success">用户</el-tag>
            <el-tag v-else type="danger">主播</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="countryCode" label="国家" align="center">
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center">
        </el-table-column>
        <el-table-column prop="fixTime" label="修改时间" align="center">
        </el-table-column>
        <el-table-column prop="valid" label="状态" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.valid == 1">有效</el-tag>
            <el-tag v-else type="warning">无效</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="operator" label="操作人" align="center">
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="danger" @click="bdDisband(scope.row.rid)"
              >解散</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <!-- 分页 -->
    <el-row>
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="pageSize"
        :current-page.sync="currentPage"
        @current-change="guaranteedHandleCurrentChange"
      >
      </el-pagination>
    </el-row>
    <!-- 弹窗 -->
    <el-dialog
      @close="close"
      :visible.sync="dailogShow"
      :title="dailogType == 0 ? '注册' : '升级'"
      width="30%"
    >
      <el-row>
        <span>rid：</span>
        <el-input style="width: 200px" v-model="form.rid"></el-input>
      </el-row>
      <el-row>
        <el-button style="margin-right: 10px" @click="close">取消</el-button>
        <el-popconfirm title="是否确认？" @confirm="submit">
          <el-button slot="reference" type="primary">确认</el-button>
        </el-popconfirm>
      </el-row>
    </el-dialog>
  </el-card>
</template>

<script>
export default {
  data() {
    return {
      tableList: [],
      search: {
        rid: null,
      },
      form: {
        rid: null,
      },
      currentPage: 1,
      total: 0,
      pageSize: 20,
      dailogShow: false,
      // 0 注册 1 升级
      dailogType: 0,
    }
  },
  created() {
    this.getList(1)
  },
  methods: {
    close() {
      this.form.rid = null
      this.dailogShow = false
    },
    submit() {
      const rid = this.form.rid
      if (this.dailogType == 0) {
        this.bdRegister(rid)
      } else {
        this.bdPromotion(rid)
      }
    },
    show(type) {
      this.dailogType = type
      this.dailogShow = true
    },
    guaranteedHandleCurrentChange(page) {
      this.currentPage = page
      getList()
    },
    // 获取数据列表
    async getList(page) {
      if (page) {
        this.currentPage = 1
      }
      const { data: res } = await this.$axios({
        method: 'get',
        url: this.$store.getters.path.game_bd_query,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          ...this.search,
          page: this.currentPage,
        },
      })
      if (res.code === 0 || res.status === 0) {
        this.tableList = res.data.data
        this.total = res.data.total
      } else {
        this.$message.error(res.msg || res.message)
      }
    },
    // 注册
    async bdRegister(rid) {
      if (!rid) return this.$message.error('rid不能为空')
      const { data: res } = await this.$axios({
        method: 'get',
        url: this.$store.getters.path.game_bd_register,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          rid,
        },
      })
      if (res.code === 0 || res.status === 0) {
        this.$message.success('注册成功')
        this.close()
        this.getList()
      } else {
        this.$message.error(res.msg || res.message)
      }
    },
    // 解散
    async bdDisband(rid) {
      if (!rid) return this.$message.error('rid不能为空')
      const { data: res } = await this.$axios({
        method: 'get',
        url: this.$store.getters.path.game_bd_disband,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          rid,
        },
      })
      if (res.code === 0 || res.status === 0) {
        this.$message.success('解散成功')
        this.getList()
      } else {
        this.$message.error(res.msg || res.message)
      }
    },
    // 升级BD
    async bdPromotion(rid) {
      if (!rid) return this.$message.error('rid不能为空')
      const { data: res } = await this.$axios({
        method: 'get',
        url: this.$store.getters.path.game_bd_promotion,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          rid,
        },
      })
      if (res.code === 0 || res.status === 0) {
        this.$message.success('升级成功')
        this.close()
        this.getList()
      } else {
        this.$message.error(res.msg || res.message)
      }
    },
  },
}
</script>

<style scoped lang="scss">
.game-bd {
  &__title {
    font-size: 28px;
    font-weight: 700;
    margin-bottom: 20px;
  }

  &__search {
    span {
      font-size: 20px;
      font-weight: 600;
      margin-right: 15px;
      margin-left: 15px;
    }

    .searchBtn {
      margin-left: 10px;
    }
  }
}
</style>